
import Vue from "vue";
import axios from "axios";
import Vuelidate from "vuelidate";
import * as firebase from "firebase/app";

import "firebase/auth";
import "firebase/database";
import localforage from 'localforage';
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import './registerServiceWorker';

require('materialize-css/dist/css/materialize.css');
require('materialize-css/dist/js/materialize.js');
import {restService} from "./controllers/rest.js";
var restServiceInstance = new restService();

localforage.config({
  name: 'KpisProsic'
});

Vue.use(Vuelidate);
Vue.config.productionTip = false;

axios.defaults.baseURL =
  "https://inncosys-cors.herokuapp.com/http://api.prosic.4angulo.com";
// axios.defaults.headers.common['Authorization'] = 'possible token'
axios.defaults.headers.get.Accepts = "application/json";

var config = {
  apiKey: "AIzaSyACRfwDI_-avuvl7fgVueXWbG_KQs0WLQ4",
  authDomain: "prosic-indicadores.firebaseapp.com",
  databaseURL: "https://prosic-indicadores.firebaseio.com",
  projectId: "prosic-indicadores",
  storageBucket: "prosic-indicadores.appspot.com",
  messagingSenderId: "605949795690"
};
firebase.initializeApp(config);
var unsubscribe = firebase.auth().onAuthStateChanged(function(user) {
  console.log("entro", user);
  new Vue({
    router,
    store,
    render: h => h(App),
    beforeCreate() {
      if (!user) {
        store.commit("setUser", null);
        unsubscribe();
      } else {
        this.$store.dispatch("fetchUserAccesList", { uid: user.uid });
        store.commit("setVerifyingUser", true);
        console.log(user);
        
        restServiceInstance
          .getUser(user.email)
          .then(user => {
            console.log(user, "USER MAIN");
            if (user && user.length > 0) {
              const newUser = {
                id: user.uid,
                email: user.email,
                name: user[0].name
              };
              store.commit("setUser", newUser);
              
              store.commit("setVerifyingUser", false);
            } else {
              alert("this user is not registered in prosic.com system");
              firebase.auth().signOut();
              store.commit("setVerifyingUser", false);
            }
            unsubscribe();
          })
          .catch(error => {
            console.log(error);
            store.commit("errorLogin", error.response);
            store.commit("setVerifyingUser", false);
            unsubscribe();
          });
      }
    }
  }).$mount("#app");
});

Number.prototype.formatMoney = function(c, d, t) {
  var n = this,
    c = isNaN((c = Math.abs(c))) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : "")
  );
};
Date.prototype.yyyymmdd = function() {
  var yyyy = this.getFullYear().toString();
  var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
  var dd = this.getDate().toString();

  return (
    yyyy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0])
  );
};
export const db = firebase.database();
export const firestore = firebase.firestore();
const settings = {timestampsInSnapshots: true};
firestore.settings(settings);
export const auth = firebase.auth();
export const secondApp = firebase.initializeApp(config, "secondary");
